import { RESET_ALL_INVOICE } from '../salesOrderDemand/salesOrderDemand.actionsType';
import {
    CREATE_SALES_ORDER_FAILURE,
    CREATE_SALES_ORDER_REQUEST,
    CREATE_SALES_ORDER_SUCCESS,
    CREATE_USER_FORM_SALES_ORDER,
    DELETE_SALES_ORDER_FAILURE,
    DELETE_SALES_ORDER_REQUEST,
    DELETE_SALES_ORDER_SUCCESS,
    FETCH_SALES_ORDER_FAILURE,
    FETCH_SALES_ORDER_REQUEST,
    FETCH_SALES_ORDER_SUCCESS,
    FETCH_SINGLE_SALES_ORDER_FAILURE,
    FETCH_SINGLE_SALES_ORDER_REQUEST,
    FETCH_SINGLE_SALES_ORDER_SUCCESS,
    SALES_ORDER_USERFORM_RESET,
    UPDATE_SALES_ORDER_FAILURE,
    UPDATE_SALES_ORDER_REQUEST,
    UPDATE_SALES_ORDER_SUCCESS,
    SALES_ORDER_USERFORM_DROPDOWNLIST_RESET,
    NAVIGATE_SALES_ORDER_DETAILS,
    NAVIGATE_SALES_ORDER,
    DISPATCH_SALES_ORDER_REQUEST,
    DISPATCH_SALES_ORDER_SUCCESS,
    DISPATCH_SALES_ORDER_FAILURE,
    NAVIGATE_SALES_ORDER_DEMAND,
    DEMAND_TOGGLE,
    FETCH_DEMAND_APPROVAL_STATUS_REQUEST,
    FETCH_DEMAND_APPROVAL_STATUS_SUCCESS,
    FETCH_DEMAND_APPROVAL_STATUS_FAILURE,
    FETCH_DEMAND_APPROVAL_SUMMARY_REQUEST,
    FETCH_DEMAND_APPROVAL_SUMMARY_SUCCESS,
    FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_REQUEST,
    FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_SUCCESS,
    FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_FAILURE,
    FETCH_STYLE_DETAIL_APPROVAL_HEADER_REQUEST,
    FETCH_STYLE_DETAIL_APPROVAL_HEADER_SUCCESS,
    FETCH_STYLE_DETAIL_APPROVAL_HEADER_FAILURE,
    DEMAND_RESET,
    FETCH_STYLE_DETAIL_APPROVAL_DETAIL_REQUEST,
    FETCH_STYLE_DETAIL_APPROVAL_DETAIL_SUCCESS,
    FETCH_STYLE_DETAIL_APPROVAL_DETAIL_FAILURE,
    FETCH_STYLE_DETAIL_APPROVAL_STYLE_REQUEST,
    FETCH_STYLE_DETAIL_APPROVAL_STYLE_SUCCESS,
    FETCH_STYLE_DETAIL_APPROVAL_STYLE_FAILURE,
    UPDATE_STYLE_DETAIL_APPROVAL_STATUS_REQUEST,
    UPDATE_STYLE_DETAIL_APPROVAL_STATUS_SUCCESS,
    UPDATE_STYLE_DETAIL_APPROVAL_STATUS_FAILURE,
    FETCH_SALES_ORDER_BUYER_NAME_REQUEST,
    FETCH_SALES_ORDER_BUYER_NAME_SUCCESS,
    FETCH_SALES_ORDER_BUYER_NAME_FAILURE,
    FETCH_DEMAND_STATUS_REQUEST,
    FETCH_DEMAND_STATUS_SUCCESS,
    DISPATCH_SALES_ORDER_FINAL_REQUEST,
    DISPATCH_SALES_ORDER_FINAL_SUCCESS,
    DISPATCH_SALES_ORDER_FINAL_FAILURE,
    RESET_DEMAND_STATUS,
    CANCEL_SALES_ORDER_REQUEST,
    CANCEL_SALES_ORDER_SUCCESS,
    CANCEL_SALES_ORDER_FAILURE,
    SALES_ORDER_CALL_POST_REQUEST,
    SALES_ORDER_CALL_POST_SUCCESS,
    SALES_ORDER_CALL_POST_FAILURE,
    ACCESSORIES_POST_CALL_REQUEST,
    ACCESSORIES_POST_CALL_SUCCESS,
    ACCESSORIES_POST_CALL_FAILURE,
    SALES_ORDER_GET_STYLE_STATUS_REQUEST,
    SALES_ORDER_GET_STYLE_STATUS_SUCCESS,
    SALES_ORDER_GET_STYLE_STATUS_FAILURE,
    DEMAND_TOGGLE_DUMMY,
    LOADING_SALES_ORDER_DEMAND,
    FETCH_SALES_ORDER_COMPARE_REQUEST,
    FETCH_SALES_ORDER_COMPARE_SUCCESS,
    FETCH_SALES_ORDER_COMPARE_FAILURE,
    FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_REQUEST,
    FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_SUCCESS,
    FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_FAILURE,
    SET_RADIO_BTN_SALES_ORDER_COMPARISION,
    CC_TOGGLE,
    FETCH_STYLE_PER_FABRIC_STATUS_FOR_PROCESS_SUCCESS,
    FETCH_STYLE_PER_FABRIC_STATUS_FOR_PROCESS_FAILURE,
    FETCH_STYLE_PER_FABRIC_STATUS_FOR_PROCESS_REQUEST,
    FETCH_COSTING_COMPARISION_PERIOD_WISE_SUCCESS,
    FETCH_COSTING_COMPARISION_PERIOD_WISE_FAILURE,
    FETCH_COSTING_COMPARISION_PERIOD_WISE_REQUEST,
    FETCH_GENERATE_COSTING_FABRIC_TABLE2_SUCCESS,
    FETCH_GENERATE_COSTING_FABRIC_TABLE1_SUCCESS,
    FETCH_GENERATE_COSTING_FABRIC_TABLE1_REQUEST,
    FETCH_GENERATE_COSTING_FABRIC_TABLE2_REQUEST,
    FETCH_GENERATE_COSTING_FABRIC_TABLE1_FAILURE,
    FETCH_GENERATE_COSTING_FABRIC_TABLE2_FAILURE,
    USER_BASED_LOAD_SALES_ORDER_SUCCESS,
    RESET_DATA_VERIFICATIONS,
    CREATE_FABRIC_AUTHORIZE_SALES_ORDER_SUCCESS,
    CREATE_MERCH_AUTHORIZE_SALES_ORDER_SUCCESS,
    CHECK_AUTHORIZE_SALES_ORDER_SUCCESS,
    ACCESS_OCR_LOAD_SALES_ORDER_SUCCESS,
    ACCESS_OCR_TRANS_SALES_ORDER_SUCCESS,
    FETCH_GENERATE_COSTING_FABRIC_TABLE3_SUCCESS,
    ACCESS_OCR_TRANS_SALES_ORDER_RESET,
    FETCH_GENERATE_COSTING_FABRIC_TABLE3_FAILURE,
    CLOSED_OCR_REPORTS_SUCCESS,
    CLOSED_OCR_REPORTS_REQUEST,
    CLOSED_OCR_REPORTS_FAILURE,
    FETCH_STYLE_MASTER_BY_TEMPLATE_SUCCESS,
    FETCH_STYLE_MASTER_BY_TEMPLATE_REQUEST,
    FETCH_STYLE_MASTER_BY_TEMPLATE_FAILURE,
    FETCH_STYLE_MASTER_BY_PCS_WEIGHT_REQUEST,
    FETCH_STYLE_MASTER_BY_PCS_WEIGHT_SUCCESS,
    FETCH_STYLE_MASTER_BY_PCS_WEIGHT_FAILURE,
    RESET_OCR_DATA,
    FETCH_SALES_ORDER_SUCCESS_NEW,
    FETCH_SALES_ORDER_REQUEST_NEW,
    FETCH_SALES_ORDER_FAILURE_NEW
} from './salesOrder.actionsType';

export const SALES_ORDER = 'salesOrder';

let initialState = {
    loading: false,
    DemandLoading: false,
    idDemandModal: false,
    idCCModal: false,
    demandSummary: '',
    styleDetailsApprovalSummary: [],
    styleDetailsApprovalHeader: [],
    styleDetailsApprovalDetail: [],
    styleDetailsApprovalStyle: [],
    salesOrderId: {},
    salesOrderList: [],
    userform: { fldFKUnitIdHeader: 1, fldStartDateHeader: new Date(new Date().setDate(new Date().getDate() - 15)), fldEndDateHeader: new Date(), fldIsEditqty: false },
    selectedSalesOrder: {},
    isSalesOrder: false,
    singleSalesOrderData: '',
    salesOrderBuyerNameList: [],
    demandStatus: '',
    errorMessage: '',
    SalesPostData: '',
    fldId: '',
    styleStatus: '',
    demandContentLoading: '',
    compareData: [],
    costingComparePrintData: [],
    renderGridBtn: 'fldSinglePcs',
    costingComparision: [],
    costingFabricData1: [],
    costingFabricData2: [],
    isHeaderScreen: false,
    prevQty: '',
    styleMasterByTemplate: [],
    pcsWeightData: []
};




export let salesOrderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload, salesOrderId = {}, fldId } = action;

    switch (type) {
        case FETCH_SALES_ORDER_REQUEST:
        case CREATE_SALES_ORDER_REQUEST:
        case UPDATE_SALES_ORDER_REQUEST:
        case FETCH_SINGLE_SALES_ORDER_REQUEST:
        case DELETE_SALES_ORDER_REQUEST:
        case FETCH_DEMAND_APPROVAL_STATUS_REQUEST:
        case FETCH_DEMAND_APPROVAL_SUMMARY_REQUEST:
        case FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_REQUEST:
        case FETCH_STYLE_DETAIL_APPROVAL_HEADER_REQUEST:
        case FETCH_STYLE_DETAIL_APPROVAL_DETAIL_REQUEST:
        case FETCH_STYLE_DETAIL_APPROVAL_STYLE_REQUEST:
        case UPDATE_STYLE_DETAIL_APPROVAL_STATUS_REQUEST:
        case FETCH_SALES_ORDER_BUYER_NAME_REQUEST:
        case FETCH_DEMAND_STATUS_REQUEST:
        case DISPATCH_SALES_ORDER_FINAL_REQUEST:
        case CANCEL_SALES_ORDER_REQUEST:
        case SALES_ORDER_CALL_POST_REQUEST:
        case SALES_ORDER_GET_STYLE_STATUS_REQUEST:
        case ACCESSORIES_POST_CALL_REQUEST:
        case FETCH_SALES_ORDER_COMPARE_REQUEST:
        case FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_REQUEST:
        case FETCH_COSTING_COMPARISION_PERIOD_WISE_REQUEST:
        case FETCH_GENERATE_COSTING_FABRIC_TABLE1_REQUEST:
        case FETCH_GENERATE_COSTING_FABRIC_TABLE2_REQUEST:
        case CLOSED_OCR_REPORTS_REQUEST:
        case FETCH_STYLE_MASTER_BY_TEMPLATE_REQUEST:
        case FETCH_STYLE_MASTER_BY_PCS_WEIGHT_REQUEST:
        case FETCH_SALES_ORDER_REQUEST_NEW:
            return {
                ...state,
                loading: true
            };
        case DISPATCH_SALES_ORDER_REQUEST:
            return {
                ...state,
                DemandLoading: true,
            };
        case FETCH_STYLE_MASTER_BY_PCS_WEIGHT_SUCCESS:
            return {
                ...state,
                loading: false,
                pcsWeightData: updatePayload
            }
        case CLOSED_OCR_REPORTS_SUCCESS:
            return {
                ...state,
                loading: false,
                closedOcrReports: updatePayload || []
            }
        case FETCH_STYLE_MASTER_BY_TEMPLATE_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterByTemplate: updatePayload
            }
        case FETCH_SALES_ORDER_SUCCESS_NEW:
            return {
                ...state,
                loading: false,
                salesOrderListOCR: updatePayload
            }
        case RESET_DATA_VERIFICATIONS:
            return {
                ...state,
                merchAuthorized: '',
                fabricAuthorized: ''
            }
        case LOADING_SALES_ORDER_DEMAND:
            return {
                ...state,
                demandContentLoading: payload
            }
        case FETCH_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderList: updatePayload
            };
        case USER_BASED_LOAD_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                userBasedSalesOrder: updatePayload
            }
        case CREATE_FABRIC_AUTHORIZE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricAuthorized: updatePayload
            }
        case CREATE_MERCH_AUTHORIZE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                merchAuthorized: updatePayload
            }
        case CHECK_AUTHORIZE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                checkAllUserVerified: updatePayload
            }
        case ACCESS_OCR_LOAD_SALES_ORDER_SUCCESS:
            return {
                ...state,
                OcrAccessories: updatePayload || []
            }
        case RESET_ALL_INVOICE:
            return {
                ...state,
                loading: false,
                pcsWeightData: []
            }
        case FETCH_GENERATE_COSTING_FABRIC_TABLE3_SUCCESS:
            return {
                ...state,
                loading: false,
                costingFabricData3: updatePayload,
            };
        case ACCESS_OCR_TRANS_SALES_ORDER_SUCCESS:
            return {
                ...state,
                transactionOrders: updatePayload
            }
        case ACCESS_OCR_TRANS_SALES_ORDER_RESET:
            return {
                ...state,
                transactionOrders: []
            }
        case FETCH_SALES_ORDER_BUYER_NAME_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderBuyerNameList: updatePayload
            };
        case SALES_ORDER_GET_STYLE_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                styleStatus: updatePayload
            };
        case CANCEL_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_DEMAND_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                demandStatus: updatePayload
            };
        case CREATE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                // userform: {},
                userform: { fldFKUnitIdHeader: state.userform.fldFKUnitIdHeader, fldStartDateHeader: state.userform.fldStartDateHeader, fldEndDateHeader: state.userform.fldEndDateHeader, fldIsEditqty: false },
                selectedSalesOrder: {}
            };
        case FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                costingComparePrintData: updatePayload
            };
        case FETCH_SALES_ORDER_COMPARE_SUCCESS:
            return {
                ...state,
                loading: false,
                compareData: updatePayload
            };
        case FETCH_GENERATE_COSTING_FABRIC_TABLE1_SUCCESS:
            return {
                ...state,
                loading: false,
                costingFabricData1: updatePayload
            };
        case FETCH_GENERATE_COSTING_FABRIC_TABLE2_SUCCESS:
            return {
                ...state,
                loading: false,
                costingFabricData2: [updatePayload]
            };
        case DISPATCH_SALES_ORDER_SUCCESS: {
            return {
                ...state,
                DemandLoading: false,
                DemandData: updatePayload
            };
        }
        case DISPATCH_SALES_ORDER_FINAL_SUCCESS: {
            return {
                ...state,
                loading: false
            };
        }
        case CC_TOGGLE: {
            return {
                ...state,
                idCCModal: payload
            };
        }

        case DEMAND_TOGGLE: {
            return {
                ...state,
                idDemandModal: payload,
                salesOrderId: salesOrderId,
                FldId: fldId
            };
        }

        case DEMAND_TOGGLE_DUMMY: {
            return {
                ...state,
                idDemandDummyModal: payload,
                salesOrderId: salesOrderId,
                FldId: fldId
            }
        }
        case FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_SUCCESS: {
            return {
                ...state,
                styleDetailsApprovalSummary: updatePayload
            };
        }
        case FETCH_STYLE_DETAIL_APPROVAL_HEADER_SUCCESS: {
            return {
                ...state,
                loading: false,
                styleDetailsApprovalHeader: updatePayload
            };
        }
        case FETCH_STYLE_DETAIL_APPROVAL_DETAIL_SUCCESS: {
            return {
                ...state,
                loading: false,
                styleDetailsApprovalDetail: updatePayload
            };
        }
        case FETCH_STYLE_DETAIL_APPROVAL_STYLE_SUCCESS: {
            return {
                ...state,
                loading: false,
                styleDetailsApprovalStyle: updatePayload
            };
        }
        case UPDATE_STYLE_DETAIL_APPROVAL_STATUS_SUCCESS: {
            return {
                ...state,
                loading: false
            };
        }
        case UPDATE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldFKUnitIdHeader: state.userform.fldFKUnitIdHeader, fldStartDateHeader: state.userform.fldStartDateHeader, fldEndDateHeader: state.userform.fldEndDateHeader },
                selectedSalesOrder: {}
            };
        case FETCH_SINGLE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { ...updatePayload, fldIsEditqty: false, fldStartDateHeader: state.userform.fldStartDateHeader, fldEndDateHeader: state.userform.fldEndDateHeader, fldFKUnitIdHeader: state.userform.fldFKUnitIdHeader },
                prevQty: updatePayload.fldTotalOrderQty
            };
        case FETCH_DEMAND_APPROVAL_STATUS_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_DEMAND_APPROVAL_SUMMARY_SUCCESS:
            return {
                ...state,
                demandSummary: updatePayload,
                loading: false
            };
        case FETCH_COSTING_COMPARISION_PERIOD_WISE_SUCCESS:
            return {
                ...state,
                loading: false,
                costingComparision: updatePayload,
            }
        case DELETE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_GENERATE_COSTING_FABRIC_TABLE1_FAILURE:
            return {
                ...state,
                loading: false,
                costingFabricData1: [],
            };
        case FETCH_GENERATE_COSTING_FABRIC_TABLE2_FAILURE:
            return {
                ...state,
                loading: false,
                costingFabricData2: [],
            };
        case FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_FAILURE:
        case RESET_OCR_DATA:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload,
                costingComparePrintData: []
            }


        case FETCH_GENERATE_COSTING_FABRIC_TABLE3_FAILURE:
            return {
                ...state,
                loading: false,
                costingFabricData3: [],
            };
        case FETCH_SALES_ORDER_FAILURE:
        case CREATE_SALES_ORDER_FAILURE:
        case UPDATE_SALES_ORDER_FAILURE:
        case FETCH_SINGLE_SALES_ORDER_FAILURE:
        case DELETE_SALES_ORDER_FAILURE:
        case FETCH_DEMAND_APPROVAL_STATUS_FAILURE:
        case FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_FAILURE:
        case FETCH_STYLE_DETAIL_APPROVAL_HEADER_FAILURE:
        case FETCH_STYLE_DETAIL_APPROVAL_DETAIL_FAILURE:
        case FETCH_STYLE_DETAIL_APPROVAL_STYLE_FAILURE:
        case UPDATE_STYLE_DETAIL_APPROVAL_STATUS_FAILURE:
        case FETCH_SALES_ORDER_BUYER_NAME_FAILURE:
        case DISPATCH_SALES_ORDER_FINAL_FAILURE:
        case CANCEL_SALES_ORDER_FAILURE:
        case SALES_ORDER_GET_STYLE_STATUS_FAILURE:
        case SALES_ORDER_CALL_POST_FAILURE:
        case ACCESSORIES_POST_CALL_FAILURE:
        case FETCH_SALES_ORDER_COMPARE_FAILURE:
        case FETCH_COSTING_COMPARISION_PERIOD_WISE_FAILURE:
        case CLOSED_OCR_REPORTS_FAILURE:
        case FETCH_STYLE_MASTER_BY_TEMPLATE_FAILURE:
        case FETCH_STYLE_MASTER_BY_PCS_WEIGHT_FAILURE:
        case FETCH_SALES_ORDER_FAILURE_NEW:
            return {
                ...state,
                loading: false,
                showErrorAlert: true,
                errorMessage: updatePayload
            };


        case DISPATCH_SALES_ORDER_FAILURE:
            return {
                ...state,
                DemandLoading: false,
                showErrorAlert: true,
                errorMessage: updatePayload
            };

        case CREATE_USER_FORM_SALES_ORDER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case SALES_ORDER_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKUnitIdHeader: state.userform.fldFKUnitIdHeader, fldStartDateHeader: new Date().setMonth(new Date().getMonth() - 1), fldEndDateHeader: new Date(), fldIsEditqty: false
                }
            };
        case SALES_ORDER_USERFORM_DROPDOWNLIST_RESET:
            return {
                ...state,
                userform: { ...state.userform, BuyName: '' }
            };

        case NAVIGATE_SALES_ORDER_DETAILS: {
            return {
                ...state,
                isSalesOrder: 'salesOrderDetail',
                singleSalesOrderData: updatePayload.singleSalesOrder

            };
        }
        case NAVIGATE_SALES_ORDER: {
            return {
                ...state,
                isSalesOrder: 'salesOrder'
            };
        }
        case NAVIGATE_SALES_ORDER_DEMAND: {
            return {
                ...state,
                isSalesOrder: 'salesOrderDemand',
                singleSalesOrderData: updatePayload.singleSalesOrder
            };
        }
        case DEMAND_RESET:
            return {
                ...state,
                styleDetailsApprovalSummary: [],
                styleDetailsApprovalHeader: []
            };
        case RESET_DEMAND_STATUS:
            return {
                ...state,
                demandStatus: ''
            };

        case SALES_ORDER_CALL_POST_SUCCESS:
            return {
                ...state,
                SalesPostData: updatePayload
            }
        case ACCESSORIES_POST_CALL_SUCCESS:
            return {
                ...state,
                accessoriesDemand: updatePayload
            }
        case SET_RADIO_BTN_SALES_ORDER_COMPARISION:
            return {
                ...state,
                renderGridBtn: payload
            };
        default:
            return state;
    }
};
